import React, { useState } from 'react';
import { DropdownItem, DropdownMenu, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button, Icon } from '../../../../../components/Component';
import Axios from 'axios';
import API_ROUTES from '../../../../../config/api';
import {Auth} from "aws-amplify";
import {Link} from "react-router-dom";

const Options = ({ item, triggerReload }) => {
  const [modalForm, setModalForm] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const toggleForm = () => setModalForm(!modalForm);

  /**
   * Delete an API token
   */
  const deleteWebhook = async() => {
    const user = await Auth.currentAuthenticatedUser();
    setDisabled(true);

    await Axios(
      API_ROUTES.webhooks['webhook:delete'](item.id),
      {
        method: 'delete',
        headers: { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` },
      }
    );

    setModalForm(false);
    triggerReload();
  };

  return (
    <React.Fragment>
      <DropdownMenu end>
        <ul className="link-list-plain">
          <li>
            <Link to={`/developers/webhook/${item.id}`}>Manage Notifications</Link>
          </li>
          <li>
            <DropdownItem
              tag="a"
              href="#view"
              onClick={(ev) => {
                ev.preventDefault();
                toggleForm();
              }}
            >
              Delete Webhook
            </DropdownItem>
          </li>
        </ul>
      </DropdownMenu>

      <Modal isOpen={modalForm} toggle={toggleForm} >
        <ModalHeader
          toggle={toggleForm}
          className=" bg-red-600 text-white text-2xl"
          close={
            <button className="close" onClick={toggleForm}>
              <Icon name="cross" className="text-white" />
            </button>
          }
        >
          Delete Webhook
        </ModalHeader>
        <ModalBody>
          <p>Are you sure you would like to delete this webhook?</p>
        </ModalBody>
        <ModalFooter className="bg-light p-2 mt-0">
        <Button color="danger" className="bg-red-600 hover:bg-red-500 m-0" type="submit" disabled={disabled} onClick={
              (ev) => {
                ev.preventDefault();
                deleteWebhook(item);
              }
            } size="lg">
              Continue
            </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
};

export default Options;
